import React, { useState } from 'react';
import {
  Modal,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Checkbox,
} from '@nextui-org/react';
import { Tasks } from 'common/src/utils/types';
import { toast } from 'react-toastify';
import NotificationService from 'common/src/api/services/notification_service';

interface ModalNotifyAskerProps {
  isOpen: boolean;
  onClose: () => void;
  task: Tasks | null;
}

const ModalNotifyAsker: React.FC<ModalNotifyAskerProps> = ({
  isOpen,
  onClose,
  task,
}) => {
  const [isSending, setIsSending] = useState(false);
  const [shouldSendEmail, setShouldSendEmail] = useState(true);

  console.log('ModalNotifyAsker rendered, isOpen:', isOpen, 'task:', task);

  const handleNotify = async () => {
    if (task) {
      setIsSending(true);
      try {
        if (shouldSendEmail) {
          await NotificationService.notifyAsker(task);
        } else {
          toast.success('No se envió notificación por correo electrónico');
        }
      } catch (error) {
        console.error('Error sending notification:', error);
        toast.error('Error al enviar la notificación');
      } finally {
        setIsSending(false);
        onClose();
      }
    }
  };

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <ModalContent>
        <ModalHeader>Notificar al Asker</ModalHeader>
        <ModalBody>
          <p>¿Desea notificar al asker sobre el cambio de estado de la tarea?</p>
          <Checkbox
            isSelected={shouldSendEmail}
            onChange={(e) => setShouldSendEmail(e.target.checked)}
          >
            Enviar correo electrónico de notificación
          </Checkbox>
        </ModalBody>
        <ModalFooter>
          <Button
            color="danger"
            variant="light"
            onPress={onClose}
            disabled={isSending}
          >
            No
          </Button>
          <Button color="primary" onPress={handleNotify} isLoading={isSending}>
            Sí, Notificar
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ModalNotifyAsker;
